import { ParsedUrlQuery } from 'querystring';
import { productsUrlQuery } from '~/src/components/blocks/referral-products/products/products-block.constants';
import type {
    GetSeparatedProductsType,
    ProductsListByParityType,
} from '~/src/components/blocks/referral-products/products/products-blok.types';

export const getProductCodesFromUrlParams = (query: ParsedUrlQuery) => {
    const productCodes = query[productsUrlQuery];
    const productCodesFromUrlParams: string[] = [];

    if (productCodes) {
        if (Array.isArray(productCodes)) {
            productCodesFromUrlParams.push(...productCodes);
        } else {
            productCodesFromUrlParams.push(productCodes);
        }
    }

    return productCodesFromUrlParams;
};

export const getSeparatedProducts = ({
    dataProducts,
    checkedProductCodes,
    productsIsCollapsed,
    isInit,
}: GetSeparatedProductsType) => {
    const dataProductsEntries = Object.entries(dataProducts);
    let countCheckedProducts = 0;

    const data = dataProductsEntries.reduce<ProductsListByParityType>(
        (filteredProducts, currentProducts, idx) => {
            const productsGroup = currentProducts[0];
            const products = currentProducts[1];
            const conditionForDeepFilter = isInit
                ? productsIsCollapsed
                : productsIsCollapsed && checkedProductCodes.length;

            if (!products) {
                return filteredProducts;
            }

            if (!conditionForDeepFilter) {
                if (idx % 2) {
                    filteredProducts.even.push(currentProducts);
                } else {
                    filteredProducts.odd.push(currentProducts);
                }

                return filteredProducts;
            }

            const checkedProducts = products.filter((product) => {
                const productIsExist = checkedProductCodes.includes(product?.code);

                if (productIsExist) {
                    ++countCheckedProducts;
                }

                return productIsExist;
            });

            if (checkedProducts.length) {
                const productGroupCount = filteredProducts.even.length + filteredProducts.odd.length;

                if (productGroupCount % 2) {
                    filteredProducts.even.push([productsGroup, checkedProducts]);
                } else {
                    filteredProducts.odd.push([productsGroup, checkedProducts]);
                }
            }

            return filteredProducts;
        },
        { even: [], odd: [] },
    );

    return { data, countCheckedProducts };
};
